import { motion } from 'framer-motion';
import { Phone, MessageCircle } from 'lucide-react';

const WHATSAPP_NUMBER = '918880331224';
const PHONE_NUMBER = '+918880331224';

export default function FloatingButtons() {
  const handleWhatsAppClick = () => {
    const message = encodeURIComponent('Hello! I am interested in your construction and interior design services. Can you please provide more information?');
    window.open(`https://wa.me/${WHATSAPP_NUMBER}?text=${message}`, '_blank');
  };

  const handleCallClick = () => {
    window.location.href = `tel:${PHONE_NUMBER}`;
  };

  return (
    <div className="fixed bottom-6 right-6 z-50 flex flex-col gap-4" data-testid="floating-buttons">
      {/* WhatsApp Button */}
      <motion.button
        initial={{ scale: 0 }}
        animate={{ scale: 1 }}
        transition={{ delay: 1, type: 'spring', stiffness: 200 }}
        onClick={handleWhatsAppClick}
        className="whatsapp-float"
        aria-label="Chat on WhatsApp"
        data-testid="whatsapp-float-btn"
      >
        <MessageCircle size={28} className="text-gray-900" fill="white" />
      </motion.button>

      {/* Call Button */}
      <motion.button
        initial={{ scale: 0 }}
        animate={{ scale: 1 }}
        transition={{ delay: 1.2, type: 'spring', stiffness: 200 }}
        onClick={handleCallClick}
        className="call-float"
        aria-label="Call Us"
        data-testid="call-float-btn"
      >
        <Phone size={26} className="text-[#0A0A0A]" />
      </motion.button>
    </div>
  );
}
